import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  img {
    &.shadow {
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15);
    }
    &.medium {
      height: ${spacing(5)};
    }
    &.large {
      height: ${spacing(7)};
    }
  }
`
